import type { ReactNode } from "react";
import { useCallback } from "react";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";

type PosteVacantOption = "all" | "occupied" | "vacant";

const posteVacantToBooleanMap: Record<PosteVacantOption, boolean | undefined> = {
  occupied: false,
  vacant: true,
  all: undefined,
};

const booleanToPosteVacantMap: Record<string, PosteVacantOption> = {
  false: "occupied",
  true: "vacant",
  undefined: "all",
};

interface PosteVacantRadioGroupProps {
  isVacant: boolean | undefined;
  onChange?: (isVacant?: boolean) => void;
}
export function PosteVacantRadioGroup({
  isVacant,
  onChange,
}: Readonly<PosteVacantRadioGroupProps>): ReactNode {
  const onRadioChange = useCallback(
    (e: React.SyntheticEvent, newValue: string) => {
      e.preventDefault();
      e.stopPropagation();
      const value = newValue as PosteVacantOption;
      onChange?.(posteVacantToBooleanMap[value]);
    },
    [onChange]
  );

  const onLabelClick = useCallback(
    (value: PosteVacantOption) =>
      function innerHandler(e: React.SyntheticEvent) {
        onRadioChange(e, value);
      },
    [onRadioChange]
  );

  return (
    <FormControl fullWidth>
      <RadioGroup
        row
        sx={{
          gap: "2em",
          ".Mui-checked + .MuiFormControlLabel-label": {
            color: "primary.main",
            fontWeight: "500",
          },
        }}
        value={booleanToPosteVacantMap[String(isVacant)]}
        onChange={onRadioChange}>
        <FormControlLabel
          label="Tous"
          value="all"
          control={<Radio />}
          onClick={onLabelClick("all")}
        />
        <FormControlLabel
          label="Occupés"
          value="occupied"
          control={<Radio />}
          onClick={onLabelClick("occupied")}
        />
        <FormControlLabel
          label="Vacants"
          value="vacant"
          control={<Radio />}
          onClick={onLabelClick("vacant")}
        />
      </RadioGroup>
    </FormControl>
  );
}
